<script lang="ts">
	import Checkbox from "./Checkbox.svelte";

	let formControlClass = "";
	export { formControlClass as class };
	export let name: string;
	export let id: string = name;
	export let approvedAt: string | null = null;

	let input: HTMLInputElement | null = null;

	$: {
		if (input) {
			input.checked = Boolean(approvedAt);
		}
	}

	function checked(event: Event): void {
		const input = event.target as HTMLInputElement;
		approvedAt = input.checked ? new Date().toISOString() : null;
	}
</script>

<div class="relative">
	<Checkbox bind:input {id} name="" on:change={checked} required class={formControlClass}>
		<slot />
	</Checkbox>
	<input type="hidden" {name} value={approvedAt ?? ""} />
</div>
